import useCurrency from '../composables/useCurrency'
export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.vueApp.directive('number', {
		created(el: HTMLDivElement, binding) {
			if (typeof binding.value === 'boolean' && binding.value) {
				el.addEventListener('input', (t: Event) => {
					const target = t.target as HTMLSelectElement
					target.value = target.value.replace(/\D+/g, '')
				})
			}
		}
	})

	nuxtApp.vueApp.directive('naira', {
		created(el: HTMLDivElement, binding) {
			if (binding.value) {
				el.addEventListener('input', (t: Event) => {
					const target = t.target as HTMLSelectElement
					target.value = useCurrency().currencyToNaira(target.value) || ''
				})
			}
		}
	})

	nuxtApp.vueApp.directive('format', {
		created(el: HTMLDivElement, binding) {
			if (typeof binding.value === 'boolean' && binding.value) {
				el.inputMode = 'numeric'

				el.addEventListener('input', event => {
					// The idea is to format a number that comes from a string and parse it back to a formatted string in the input
					const inputTarget = event.target as HTMLInputElement
					const targetValue = inputTarget.value
					if (targetValue !== '') {
						const value = parseFloat(String(inputTarget.value).replaceAll(/[^\d.-]/g, '')) ?? 0
						inputTarget.value = Number(value).toLocaleString('en-US')
					} else {
						inputTarget.value = ''
					}
				})
			}
		}
	})
})
